var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestCloudTunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6sqs1pt2ua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.23c0-.29.235-.525.525-.525h8.6c.281.894.749 1.818 1.487 2.625H2.1a2.1 2.1 0 0 1-2.1-2.1zm1.75-8.4c0-.966.785-1.75 1.75-1.75H14c.965 0 1.75.784 1.75 1.75v3.387l-1.619-.648c-.043-.016-.087-.032-.131-.046V2.83H3.5v7H1.75v-7zm7.875 5.468a.66.66 0 0 1 .413-.61l3.281-1.312a.652.652 0 0 1 .487 0l3.281 1.313a.66.66 0 0 1 .413.61c0 1.73-.708 4.615-3.683 5.856a.65.65 0 0 1-.506 0c-2.978-1.241-3.686-4.126-3.686-5.857zm3.938-.607v5.138c1.864-.902 2.501-2.707 2.608-4.093-.87-.347-1.739-.697-2.608-1.045z",
    fill: "#233145"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6sqs1pt2ua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .205)",
    d: "M0 0h17.5v14H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCloudTunnel);
export default __webpack_public_path__ + "static/media/test-cloud-tunnel.12af32d0fc9588d8269e4b3dc6f475b8.svg";
export { ForwardRef as ReactComponent };